import { render, staticRenderFns } from "./BorrowTokenPanel.vue?vue&type=template&id=bcc0626c&scoped=true&"
import script from "./BorrowTokenPanel.vue?vue&type=script&lang=js&"
export * from "./BorrowTokenPanel.vue?vue&type=script&lang=js&"
import style0 from "./BorrowTokenPanel.vue?vue&type=style&index=0&id=bcc0626c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc0626c",
  null
  
)

export default component.exports